import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const holiday: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'effectiveDate' },
            { type: 'field', field: 'holidayDescription' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'holidayCountry' },
            { type: 'field', field: 'holidayFlag' },
        ],
    },
    {
        fullWidth: true,
        controls: [{ type: 'field', field: 'holidayType' }],
    },
];

export default holiday;
